















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { PartialPermission, TransactionChange, TransactionExecute, TransactionType, VueRoot } from "@/domain";
import { Field, TransactionItem } from "@/domain/types/transactions_query";
import { fieldCSS, fieldFormat, getFieldDescriptors, mapTransaction } from "@/domain/transactions_query";
import { domain } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import lodash from "lodash";
import { logError, toNumberID } from "@/util";

export interface TxnModifyEvent {
  txn: TransactionItem;
  opType: TransactionType;
  confirmKeyword: string;
  bizum: boolean;
}

@Component
export default class TxnInfoDialog extends Vue {
  // Info dialog
  @Prop({ required: true }) transactionChanges!: { [key: string]: TransactionChange };
  infoDialog = false;
  dialogData: Partial<TransactionItem> = {
    txnStatusType: {}
  };
  fieldDescriptors = getFieldDescriptors();
  prevTxnIndex: number[] = [];
  companyId = 0;
  loading = false;
  bizum = false;
  showForceDialog = false;
  savingData = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get userPermission(): PartialPermission {
    return this.$store.getters.userPermission;
  }

  get showForceSale() {
    if (this.bizum === true) return false; // No es Bizum.
    if (this.dialogData.isApproved === true) return false; // No fue aprobada.
    if (this.dialogData.type !== "sale") return false; // No es sale
    return true;
  }

  get showForceRefund() {
    if (this.bizum === true) return false; // No es Bizum.
    if (this.dialogData.isApproved === true) return false; // No fue aprobada.
    if (this.dialogData.type !== "refund") return false; // No es sale
    return true;
  }

  showItem(item: TransactionItem) {
    this.dialogData = item;
    this.infoDialog = true;
    if (item.binNumber?.substring(0, 4) === "TEL:") this.bizum = true;
    else this.bizum = false;
  }

  clearTxn() {
    this.prevTxnIndex = [];
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  amountWithCents() {
    return Number(this.dialogData.requestedAmount?.replace("-", "")) * 100;
  }

  async cmdProcess() {
    this.savingData = true;
    const request = {
      companyID: this.dialogData.companyId,
      branchID: util.toNumber(this.dialogData.branchID),
      tcod: this.dialogData.commerceTCOD,
      previousTransactionID: util.toNumber(this.dialogData.id),
      type: this.dialogData.type === "sale" ? "saleAC" : "refundAC",
      amountCents: this.amountWithCents(),
      reference: this.dialogData.transactionReference,
      comment: ""
    };
    try {
      const savedResult = await domain.backend.modifyTransaction(request as TransactionExecute);
      util.log("Transaction Ejecutada", savedResult);
      if (savedResult.transaction.approved === "S") {
        this.snackShow(this.lang.alertExecuteTransaction, "success");
        this.$emit("receipt", savedResult.transaction);
        this.savingData = false;
        this.showForceDialog = false;
        this.infoDialog = false;
      } else {
        this.snackShow(savedResult.transaction.resultText || this.lang.errorCouldNotExecuteTransaction, "error");
        this.savingData = false;
      }
    } catch (error) {
      util.logError("Error ejecutar la transacción", error);
      this.savingData = false;
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorCouldNotExecuteTransaction), "error");
    }
  }

  get groupedDetailFields() {
    const mappedItems = this.fieldDescriptors
      .filter((fld) => !!fld.details)
      .map((fld) => ({
        title: fld.title,
        field: fld.field,
        format: fld.format,
        details: fld.details
      }));
    const groups = this.groupAndSort(
      mappedItems,
      (fld) => fld.details?.group,
      (fld) => fld.details?.group
    );
    return groups.map((g) => ({
      group: g.key,
      categories: this.groupAndSort(
        g.fields,
        (fld) => fld.details?.category,
        (fld) => fld.details?.order
      )
    }));
  }

  get referencedTransactionInfo() {
    const prevTxn =
      this.dialogData?.referencedTransactions?.closedByTransaction ??
      this.dialogData?.referencedTransactions?.previousTransaction ??
      this.dialogData?.previousTransactionID;
    if (!prevTxn) return null;
    if (prevTxn === this.lastNavigatedTransaction?.transactionID) return null;
    const isClosed = !!this.dialogData?.referencedTransactions?.closedByTransaction;
    return {
      label: isClosed ? this.lang.closeCancelation : this.lang.previousOperation,
      transactionID: prevTxn
    };
  }

  get lastNavigatedTransaction() {
    if (this.prevTxnIndex.length == 0) return null;
    return {
      transactionID: this.prevTxnIndex[this.prevTxnIndex.length - 1]
    };
  }

  async navigateToReferencedTransaction() {
    const prevTxn = this.referencedTransactionInfo;
    if (!prevTxn) return;
    if (this.dialogData.companyId) this.companyId = this.dialogData.companyId;
    const prevId = toNumberID(this.dialogData.id);
    if (prevId) this.prevTxnIndex.push(prevId);
    await this.navigateToTransactionID(prevTxn.transactionID);
  }

  async navigateToPreviousTransaction() {
    const txn = this.prevTxnIndex.pop();
    if (!txn) return;
    await this.navigateToTransactionID(txn);
  }

  async navigateToTransactionID(txnId: number) {
    this.loading = true;
    try {
      const result = await domain.backend.getTransactionData({
        companyID: this.companyId,
        reference: "",
        from: "2022-08-01",
        to: "2022-09-21",
        transactionID: txnId,
        pageNum: 1,
        useLocalTime: true,
        language: this.langKey
      });
      this.showItem(mapTransaction(result.transactions[0]));
    } catch (ex) {
      logError(`Error navigating to transaction #${txnId}`, ex);
      this.snackShow("Error cargando transacción", "error");
    }
    this.loading = false;
  }

  groupAndSort<T, GK, SK>(items: T[], groupKey: (a: T) => GK, sortKey: (a: T) => SK) {
    return lodash(items)
      .groupBy(groupKey)
      .map((fields, key) => {
        return {
          key,
          fields: lodash(fields).sortBy(sortKey).value()
        };
      })
      .sortBy("key")
      .value();
  }

  get dialogDataExtra(): TransactionChange | null {
    if (!this.dialogData) {
      return null;
    }
    return this.transactionChanges["t" + this.dialogData.id] || null;
  }

  canModify(txn: TransactionItem, txnType: string[]): boolean {
    return this.userPermission.txnModification && txnType.includes(txn.type || "");
  }

  actionPreauthClose(txn: TransactionItem) {
    this.txnModify(txn, "authClose", "cerrar");
  }

  actionPreauthCancel(txn: TransactionItem) {
    this.txnModify(txn, "authCancel", "cancelar");
  }

  actionRefund(txn: TransactionItem, bizum = false) {
    this.txnModify(txn, "refund", "devolver", bizum);
  }

  actionSale(txn: TransactionItem) {
    this.txnModify(txn, "sale", "cobrar");
  }

  txnModify(txn: TransactionItem, opType: TransactionType, confirmKeyword: string, bizum = false) {
    const evt: TxnModifyEvent = { txn, opType, confirmKeyword, bizum };
    this.$emit("txn-modify", evt);
  }

  showReceipt(txn: TransactionItem) {
    this.$emit("txn-receipt", txn);
  }

  itemCSS(item: Partial<TransactionItem>, field: Field) {
    return fieldCSS(item, field);
  }

  itemFormat(item: Partial<TransactionItem>, field: Field) {
    return fieldFormat(item, field);
  }
}
